const currentBillingDefuntoStats = `
query CurrentBillingDefuntoStats($first: Int!, $where: Defunto_period_statWhereInput, $order: [Defunto_period_statOrder!]) {
  defunto_period_stats(first: $first, where: $where, order: $order) {
    edges {
      node {
        org_pointer { objectId }
        period_key
        period_start
        period_end
        last_computed_at
        period_type
        date_ref
        total_count
        breakdown
        purchased_amount
        limit_is_flat
        pct_used
        pct_projected
        expected_total
        prediction_available
        prediction_elapsed_days
        prediction_total_days
        expected_excess_on
        needs_more_data
        usage_state
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default currentBillingDefuntoStats;
